export const SPla2: React.FC = () => <>sPLA<sub>2</sub></>